/* eslint-disable import/no-extraneous-dependencies */

import { debounce, setEqualHeights } from './util';

const faqPage = (() => {
    // content-tile titles on FAQ page
    function equalContentTileTitles() {
        setEqualHeights($('.js-content-tile-title'), 4);
    }

    return {
        init() {
            equalContentTileTitles();
        },
        resize() {
            equalContentTileTitles();
        },
    };
})();

export default (() => {
    $(document).ready(faqPage.init);

    $(window).on('resize', debounce(faqPage.resize, 600));
})();
